import { render, staticRenderFns } from "./TravelPlanCard.vue?vue&type=template&id=0d9ce944&scoped=true"
import script from "./TravelPlanCard.vue?vue&type=script&lang=js"
export * from "./TravelPlanCard.vue?vue&type=script&lang=js"
import style0 from "./TravelPlanCard.vue?vue&type=style&index=0&id=0d9ce944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9ce944",
  null
  
)

export default component.exports